import React, { useState, useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { qrPatternBackgroundTransparent } from "../../../../../redux/slices/qrSettings";
import { useDebounce } from "use-debounce";
import Form from "react-bootstrap/Form";

function QrPatternBackgroundToggle() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.pattern[2]
  );
  const statePatternBackgroundTransparent = useSelector(
    (state) => state.qrSettings.patternBackgroundTransparent
  );

  const dispatch = useDispatch();

  const [patternBackgroundTransparent, setPatternBackgroundTransparent] =
    useState(statePatternBackgroundTransparent);
  const [value] = useDebounce(patternBackgroundTransparent, 100);

  useEffect(() => {
    setPatternBackgroundTransparent(statePatternBackgroundTransparent);
  }, [statePatternBackgroundTransparent]);

  useEffect(() => {
    dispatch(qrPatternBackgroundTransparent(value));
  }, [value]);

  return (
    <>
      <Form.Check
        type="switch"
        id="custom-switch"
        className="text-capitalize"
        label={lang}
        checked={patternBackgroundTransparent}
        onChange={() => {
          setPatternBackgroundTransparent(!patternBackgroundTransparent);
        }}
      />
    </>
  );
}

export default memo(QrPatternBackgroundToggle);
